import { Box, Group, Progress, Stack, Text } from "@mantine/core";
import type { IForenkletStyringNivaa1Report } from "@mcapps/shared/startupChecklists/templates/902-forenklet-styring/902InitialData";
import { get902Stats } from "@mcapps/shared/startupChecklists/templates/902-forenklet-styring/902Stats";

const segments = [
  { key: "RED", label: "Høy risiko", color: "#c92a2a" },
  { key: "YELLOW", label: "Middels risiko", color: "#e5ae00" },
  { key: "LIGHT_GREEN", label: "Ikke kommunisert", color: "#7dc67b" },
  { key: "DARK_GREEN", label: "Avklart", color: "#237a45" },
  { key: "BLUE", label: "Mulighet", color: "#2775b6" },
  { key: "GRAY", label: "Ikke relevant", color: "#868e96" },
  { key: "unanswered", label: "Ubesvart", color: "var(--mantine-color-gray-3)" },
] as const;

export const Progress902 = ({ report }: { report: IForenkletStyringNivaa1Report }) => {
  const stats = get902Stats(report);
  return (
    <Stack gap={4} style={{ flex: "1 1 340px", maxWidth: 600, minWidth: 0 }}>
      <Group justify="space-between" gap="xs">
        <Text size="xs" fw={500}>{stats.completionPercent} % avklart</Text>
        <Text size="xs" c="dimmed">{stats.resolved} av {stats.total} spørsmål · {stats.processed} vurdert</Text>
      </Group>
      <Progress.Root h={16} radius={4} aria-label="Fremdrift for hele sjekklisten">
        {segments.map(({ key, label, color }) => (
          <Progress.Section key={key} value={stats.percentages[key]} color={color} aria-label={`${label}: ${stats.counts[key]}`} />
        ))}
      </Progress.Root>
      <Group gap="sm" wrap="wrap">
        {segments.map(({ key, label, color }) => (
          <Group key={key} gap={4} wrap="nowrap">
            <Box aria-hidden style={{ width: 7, height: 7, borderRadius: 2, background: color }} />
            <Text size="xs" c="dimmed">{stats.counts[key]} {label}</Text>
          </Group>
        ))}
      </Group>
    </Stack>
  );
};